import { makeActionCreator } from '../../config/store/utils'
import { getContingencyExpense } from '../../services/contingencies'

export const GET_CONTINGENCY_EXPENSE = 'GET_CONTINGENCY_EXPENSE'
export const GET_CONTINGENCY_EXPENSE_ERROR = 'GET_CONTINGENCY_EXPENSE_ERROR'
export const GET_CONTINGENCY_EXPENSE_SUCCESS = 'GET_CONTINGENCY_EXPENSE_SUCCESS'
export const onGetContingencyExpense = makeActionCreator(GET_CONTINGENCY_EXPENSE)
export const onGetContingencyExpenseError = makeActionCreator(GET_CONTINGENCY_EXPENSE_ERROR, 'payload')
export const onGetContingencyExpenseSuccess = makeActionCreator(GET_CONTINGENCY_EXPENSE_SUCCESS, 'payload')
export const onGetContingencyExpenseThunk =
  ({ contingencyId, year }) =>
  async dispatch => {
    dispatch(onGetContingencyExpense())

    try {
      const { data } = await getContingencyExpense({ contingencyId, year })

      return dispatch(onGetContingencyExpenseSuccess({ contingencyExpense: data?.payload[0]?.data }))
    } catch (error) {
      return dispatch(onGetContingencyExpenseError({ error }))
    }
  }
